<ion-item
  class="radio-skeleton-item accordion-item-radio-container"
  lines="none"
>
  <ion-radio class="accordion-radio-button"></ion-radio>
  <ion-title class="accordion-text-title">
    <ion-skeleton-text
      animated
      style="width: 90%"
    ></ion-skeleton-text>
  </ion-title>
</ion-item>